 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import WELCOME from '@/components/welcome'
 import DEDICATION from '@/components/dedication'
 import PART001 from '@/components/part001'
 import PART002 from '@/components/part002'
 import PART003 from '@/components/part003'
 import PART004 from '@/components/part004'
 import PART005 from '@/components/part005'
 import PART006 from '@/components/part006'
 import PART007 from '@/components/part007'
 import PART008 from '@/components/part008'
 import PART009 from '@/components/part009'
 import PART010 from '@/components/part010'
 import PART010A from '@/components/part010a'
 import LOVE_2 from '@/components/love_2'
 import PERSONBLURB from '@/components/personblurb'
 import ADCARD from '@/components/ad-card'
 import NEWSLETTERSIGNUP from '@/components/newsletterSignup'
 import TOC from '@/components/toc'
 import COPYRIGHT from '@/components/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/welcome",
 			"name" : "welcome",
 			"component" : WELCOME
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/part001",
 			"name" : "part001",
 			"component" : PART001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js